import type { HasilZaka, JariMasukan } from "@dfa/types";
import { hitungHulu } from "./hulu.js";
import { hitungTurunan } from "./turunan.js";

export { hitungHulu, kodeKeLobus } from "./hulu.js";
export { hitungTurunan, PETA_MI, URUTAN_MI } from "./turunan.js";

/** Satu pintu masuk: 10 jari → seluruh isi laporan Zaka. */
export function hitungZaka(jari: JariMasukan[]): HasilZaka {
  const hulu = hitungHulu(jari);
  const turunan = hitungTurunan(hulu);
  return {
    TNGF: hulu.TNGF,
    jariX: hulu.jariX,
    lobus_nilai: hulu.lobus_nilai,
    lobus_persen: hulu.lobus_persen,
    lobus_X: hulu.lobus_X,
    ...turunan,
    karakter: null,
    karakter_alasan: "menunggu uji 8.3",
    atd: null,
  };
}
